// extracted by mini-css-extract-plugin
module.exports = {"tableBorded":"detailContent_tableBorded__3aG5Q"};